import React from 'react';
import { getSystemError } from '../../getUrls';
import { EnvironmentService } from '../../services/EnvironmentService';
import { EskimosLoginPageTemplate } from './template/eskimos/EskimosLoginPageTemplate';
import { KutubeeLoginPageTemplate } from './template/kutubee/KutubeeLoginPageTemplate';
import { ToBuildAProfileLoginPageTemplate } from './template/2bap/2bapLoginPageTemplate';
import RoutePath from 'constants/routePath';

var LoginWidget = require("./widget/loginWidget");
var AuthenticationAction = require('../../action/authenticationAction');
var AuthenticationStore = require("../../store/authenticationStore");
var RouterUtility = require('../../utils/routerUtility');
var AuthType = require('../../constants/auth/authType');

var translate = ReactI18n.translate;

const envService = new EnvironmentService();

/**
 * Login View controller
 */
  // TODO investigate why the component is remounted while authentication and login redirect are being performed
var LoginPage = React.createClass({

  contextTypes: {
    router: React.PropTypes.object
  },

  getInitialState: function () {
    return {
      errorMessage: null,
      ssoChecking: false,
      external2bapChecking: false,
      actAsChecking: false
    };
  },


  componentWillMount: function () {

    // prevents redundant authentication checks and redirects when component is unexpectedly remounted (see the TODO above)
    if (this.context.router.getCurrentLocation().pathname !== RoutePath.ROUTE_LOGIN) {
      return;
    }

    AuthenticationStore.addChangeListener(this._onChange);

    var isLoggedIn = AuthenticationStore.isLoggedIn(),
      returnUrl = RouterUtility.getReturnUrlParameter(),
      is2bapExternalAuth = this._checkIs2bapExternalAuth(),
      isSsoAuth = this._checkIsSsoAuth(),
      isActAsAuth = this._checkIsActAsAuth();

    if (is2bapExternalAuth) {
      this._perform2bapExternalAuth(returnUrl);
      return;
    }

    if (isLoggedIn) {
      AuthenticationAction.loginRedirect(this.context.router, returnUrl);
    } else if (isSsoAuth) {
      this.setState({ssoChecking: true});
      var ssoData = this._formSsoData();
      AuthenticationAction.signInSso(ssoData, returnUrl, this.context.router).catch(() => {
        this._redirectOnError();
      });
    }
    else if (isActAsAuth) {
      this.setState({actAsChecking: true});
      var data = this._formActAsData();
      AuthenticationAction.signInActAs(data, returnUrl, this.context.router).catch(() => {
        this._redirectOnError();
      });
    }
  },

  _perform2bapExternalAuth: function(returnUrl) {
    console.log(returnUrl)
    if (AuthenticationStore.get2bapExternalCheckingStatus()) {
      return;
    }

    this.setState({ external2bapChecking: true });
    const _2bapData = this._form2bapExternalAuthData();
    AuthenticationAction.signIn2bapExternal(_2bapData, returnUrl, this.context.router).catch(() => {
      this._redirectOnError();
    });
  },

  _checkIs2bapExternalAuth: function () {
    var token = RouterUtility.get2bapExternalTokenParameter();
    return Boolean(token && this._checkIsSsoAuth());
  },

  _checkIsSsoAuth: function () {
    var type = RouterUtility.getTypeParameter();
    var isSsoAuth = (!!type && type === AuthType.TYPE_EXTERNAL);
    return isSsoAuth;
  },

  _checkIsActAsAuth: function () {
    var type = RouterUtility.getTypeParameter();
    var isActAsAuth = (!!type && type === AuthType.TYPE_ACT_AS);
    return isActAsAuth;
  },

  _form2bapExternalAuthData: function () {
    return {
      sessionId: RouterUtility.getSessionParameter(),
      _2bap_external_token: RouterUtility.get2bapExternalTokenParameter()
    }
  },

  _formSsoData: function () {
    return {
      sessionId: RouterUtility.getSessionParameter(),
      token: RouterUtility.getTokenParameter()
    };
  },

  _formActAsData: function () {
    return {
      sessionId: RouterUtility.getSessionParameter()
    };
  },

  componentWillUnmount: function () {
    AuthenticationStore.removeChangeListener(this._onChange);
  },

  _onChange: function (error) {
    this.setState({
      ssoChecking: AuthenticationStore.getSsoCheckingStatus(),
      external2bapChecking: AuthenticationStore.get2bapExternalCheckingStatus(),
      actAsChecking: AuthenticationStore.getActAsCheckingStatus(),
      errorMessage: error
    });
  },

  render: function () {

    if (((!!this.state.ssoChecking || !!this.state.actAsChecking || !!this.state.external2bapChecking) && !this.state.errorMessage)
      || AuthenticationStore.isLoggedIn()) return null;

    return this.resolveTemplate();
  },

  resolveTemplate() {
    const { t } = this.props;

    if (envService.isKutubee) {
      return <KutubeeLoginPageTemplate t={t}>{ this.getLoginWidget() }</KutubeeLoginPageTemplate>;
    }

    if (envService.is2bap) {
      return <ToBuildAProfileLoginPageTemplate>{ this.getLoginWidget() }</ToBuildAProfileLoginPageTemplate>
    }

    return <EskimosLoginPageTemplate t={t}>{ this.getLoginWidget() }</EskimosLoginPageTemplate>;
  },

  getLoginWidget() {
    return (
      <LoginWidget
        onSignIn={this._signInHandler}
        isLoginLoading={this.state.isLoginLoading}
        errorMessage={this.state.errorMessage}
      />
    )
  },

  getUrlParam(key){
    var {location} = this.props;
    if (!location) return null;

    var {query} = location;
    if (!query) return null;

    return query.hasOwnProperty(key) ? query[key] : null;
  },


  /* <editor-fold desc="[ account handlers ]">*/
  _signInHandler: function (loginData) {
    var returnUrl = RouterUtility.getReturnUrlParameter();
    this._setLoginLoadingStatus(true);
    var disableSpinner = () => this._setLoginLoadingStatus(false);
    AuthenticationAction.signIn(loginData, returnUrl, this.context.router)
      .then(disableSpinner)
      .catch(() => {
        this._redirectOnError();
      });
  },

  _redirectOnError() {
    const { router } = this.props;
    router.push(getSystemError())
  },

  _setLoginLoadingStatus(isLoading){
    this.setState({
      isLoginLoading: isLoading
    });
  }
  /* </editor-fold desc="[ account handlers ]">*/
});

module.exports = translate(['main'], {withRef: false, wait: true})(LoginPage);
